import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  ReviewListApiResponse,
  ReviewTableFilterParams,
} from "interface/review";

const getFormattedParams = (params: ReviewTableFilterParams = {}) => {
  const formatted: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.pageSize ?? 10,
  };
  if (params.sortField && params.sortOrder) {
    formatted.sort = params.sortField;
    formatted.direction = params.sortOrder === "ascend" ? "asc" : "desc";
  }
  const bookingNumber = Array.isArray(params.booking_number)
    ? params.booking_number[0]
    : params.booking_number;
  if (bookingNumber) formatted.booking_number = bookingNumber;
  const bookingId = Array.isArray(params.booking_id)
    ? params.booking_id[0]
    : params.booking_id;
  if (bookingId) formatted.booking_id = bookingId;
  const userId = Array.isArray(params.user_id)
    ? params.user_id[0]
    : params.user_id;
  if (userId) formatted.user_id = userId;
  const driverId = Array.isArray(params.driver_id)
    ? params.driver_id[0]
    : params.driver_id;
  if (driverId) formatted.to = driverId;
  const reviewText = Array.isArray(params.review)
    ? params.review[0]
    : params.review;
  if (reviewText && String(reviewText).trim())
    formatted.review = String(reviewText).trim();
  const createdAt = Array.isArray(params.createdAt)
    ? params.createdAt[0]
    : params.createdAt;
  if (createdAt) formatted.createdAt = createdAt;
  if (params.rating?.length) formatted.rating = params.rating.join("-");
  return formatted;
};

export const reviewApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReviews: builder.query<ReviewListApiResponse, ReviewTableFilterParams>({
      query: (params) => ({
        url: API.GET_REVIEW,
        method: "GET",
        params: getFormattedParams(params),
      }),
      providesTags: ["Review"],
    }),
    deleteReview: builder.mutation<
      { statusCode: number; message: string; data?: unknown },
      string
    >({
      query: (id) => ({
        url: `/${API.GET_REVIEW}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Review", "Driver"],
    }),
  }),
});

export const { useGetReviewsQuery, useDeleteReviewMutation } = reviewApi;
